import { Fragment, useState } from "react"
import { RightDrawer } from "../../../Component/MuiEx"
import MemberEditForm from "./MemberEditForm"
import {  EditOutlined, PersonOutline } from "@mui/icons-material"
import { Box, Tooltip, Typography } from "@mui/material"
import UserEditForm from "./UserEditForm"
import { apiResult, getUserSession } from "../../../Utils/Common"
import apis from "../../../api"

const MemberItem = (props)=>{
    const {member,onError} = props
    const [rightDrawer,setRightDrawer] = useState()
    const [color,setColor] = useState("#8886")
    getUserSession(apis)
    const handleClick = ()=>{
        setRightDrawer(<MemberEditForm id={member?.id} user_id={member?.user_id} title="View & Edit Member" onClose={() => setRightDrawer()} />)
    }
    const handleParentClick = ()=>{
        if (member.parent) {
            setRightDrawer(<UserEditForm user={member?.parent} onClose={() => setRightDrawer()} title="View & Edit Parent" />)
        } else {
            apis.loadParent(member.user_id).then(ret => {
                apiResult(ret, data => {
                    member.parent = data.user_profile
                    data.user_profile.id = data.id
                    data.user_profile.area_id = data.area_id                    
                    setRightDrawer(<UserEditForm user={data.user_profile} onClose={() => setRightDrawer()} title="View & Edit Parent" />)
                }, onError)
            })
        }
    }
    const handleRightDrawer = () => {
        setRightDrawer()
    }
    const handleMouseOver = ()=>{
        setColor("#888")
    }
    
    const handleMouseOut = ()=>{
        setColor("#8886")
    }
    return <Box sx={{...props.sx,display:"flex"}} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
        <Typography>{member?.name}</Typography>
        <Tooltip title="View & Edit Member"  sx={{cursor:"pointer",ml:1,color:color}} ><EditOutlined fontSize="small" onClick={handleClick}/></Tooltip>
        <Tooltip title="View & Edit Parent"  sx={{cursor:"pointer",ml:1,color:color}} ><PersonOutline fontSize="small" onClick={handleParentClick}/></Tooltip>
        <RightDrawer toggleDrawer={handleRightDrawer} open={rightDrawer ? true : false}>
            {rightDrawer}
        </RightDrawer>
        </Box>
}

export {MemberItem}